import React from 'react';
import Timetable from "./Timetable";

function ScheduleAsTimetable({match}) {

    const formatDateForRequest = (date) => {
        // Date should be received in format dd-mm-yyyy and passed to request in format dd/mm/yyyy
        return date.substring(0, 10).replace(new RegExp("-", 'g'), "/");
    }

    let eventsDataUrl = "";

    switch (match.params.date) {
        case "today":
            eventsDataUrl = "cms/dailySchedule";
            break;
        case "tomorrow":
            eventsDataUrl = "cms/dailyScheduleTomorrow";
            break;
        default:
            eventsDataUrl = `cms/dailyScheduleByDate?date=${formatDateForRequest(match.params.date)}`;
            break;
    }

    return (
        <Timetable eventsDataUrl={eventsDataUrl} />
    );
}

export default ScheduleAsTimetable;